import { createAction } from '@reduxjs/toolkit';

// Event Action of type Track
/* `const segmentTrack = createAction('segment/track');` is creating an action creator function using
the `createAction` function from the `@reduxjs/toolkit` library. This action creator function will
return an action object with a `type` property set to `'segment/track'` when it is called. This
action can then be dispatched to the Redux store to trigger a state update or other side effects. */
const segmentTrack = createAction('segment/track');

// Event Action of type Impression
/* `const segmentImpression = createAction('segment/impression');` is creating an action creator
function using the `createAction` function from the `@reduxjs/toolkit` library. This action creator
function will return an action object with a `type` property set to `'segment/impression'` when it
is called. This action can then be dispatched to the Redux store to trigger a state update or other
side effects. */
const segmentImpression = createAction('segment/impression');

/* `const segmentIdentify = createAction('segment/identify');` is creating an action creator function
using the `createAction` function from the `@reduxjs/toolkit` library. This action creator function
will return an action object with a `type` property set to `'segment/identify'` when it is called.
This action can then be dispatched to the Redux store to trigger a state update or other side
effects. */
const segmentIdentify = createAction('segment/identify');

/* `const segmentPageView = createAction('segment/pageview');` is creating an action creator function
using the `createAction` function from the `@reduxjs/toolkit` library. This action creator function
will return an action object with a `type` property set to `'segment/pageview'` when it is called.
This action can then be dispatched to the Redux store to trigger a state update or other side
effects. */
const segmentPageView = createAction('segment/pageview');

export { segmentTrack, segmentImpression, segmentIdentify, segmentPageView };
